// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-item-info__mailing-fields {
    width: 110rem;
}

.mailing-item-info__name-input {
    width: 27rem !important;
    text-align: left;
    float: left;
}

.mailing-item-info__mailing-fields input.mailing-item-info__name-input {
    padding-bottom: 5px;
    height: auto;
    margin-top: 22px;
}

.mailing-item-info__mailing-field input.mailing-item-info__text-input {
    padding-bottom: 5px;
    height: auto !important;
    margin-top: 22px;
}

.mailing-item-info__mailing-field {
    display: flex;
    margin-top: 1rem;
    float: left;
    width: 100%;
}

.mailing-params-container {
    display: flex;
    flex-direction: column;
}

.mailing-params-checkbox {
    margin-left: -1.5rem;
    margin-top: 1.35rem;
    float: left;
    font-size: large;
    width: fit-content;
    padding-left: 2px;
}

.mailing-type-tabs-wrapper {
    margin: 1.5rem 4rem;
    height: 4rem;
    width: fit-content;
    white-space: nowrap;
    float: left;
    border-bottom: 1px solid rgb(161, 161, 161);
    min-height: 4rem;
    line-height: 4rem;
}

.mailing-type-tabs-wrapper span{
    margin-left: 1.6rem;
    margin-right: 1.6rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    padding-bottom: 0.8rem;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    margin-top: auto;
}

.mailing-type-tabs-wrapper span.active{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}

.mailing-item-info__channels-block {
    width: 75%;
    display: block;
}

.mailing-item-info__channels-label {
    float: left;
    min-width: 9rem;
    height: 100%;
}

.mailing-item-info__channels-choose {
    text-align: left;
    float: left;
    display: grid;
    margin-left: -2rem;
    padding-left: 2px;
}

.mailing-item-info__channels-choose .visible-checkbox {
    margin-left: 1.8rem;
    margin-right: .5rem;
    position: relative;
    opacity: 1; 
    pointer-events: all;
}

.mailing-item-info__choosen-channels {
    width: 70%;
    float: left;
}

.mailing-item-info__channel-container {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.mailing-item-info__channel-image {
    width: 2.6rem;
    height: 2.6rem;
    margin-left: .5rem;
}

.mailing-item-info__channel-externalid {
    vertical-align: 0.6rem;
    margin-left: 1.8rem;
}

.channels-selector-wrapper {
    margin-left: 16rem;
    width: 65%;
    height: 42rem;
    max-height: 42rem;
    border: 1px solid #dcdcdc;
    padding: 1rem;
    border-radius: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-item-info/CreateMailingInfo/CreateMailingInfo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".mailing-item-info__mailing-fields {\r\n    width: 110rem;\r\n}\r\n\r\n.mailing-item-info__name-input {\r\n    width: 27rem !important;\r\n    text-align: left;\r\n    float: left;\r\n}\r\n\r\n.mailing-item-info__mailing-fields input.mailing-item-info__name-input {\r\n    padding-bottom: 5px;\r\n    height: auto;\r\n    margin-top: 22px;\r\n}\r\n\r\n.mailing-item-info__mailing-field input.mailing-item-info__text-input {\r\n    padding-bottom: 5px;\r\n    height: auto !important;\r\n    margin-top: 22px;\r\n}\r\n\r\n.mailing-item-info__mailing-field {\r\n    display: flex;\r\n    margin-top: 1rem;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.mailing-params-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.mailing-params-checkbox {\r\n    margin-left: -1.5rem;\r\n    margin-top: 1.35rem;\r\n    float: left;\r\n    font-size: large;\r\n    width: fit-content;\r\n    padding-left: 2px;\r\n}\r\n\r\n.mailing-type-tabs-wrapper {\r\n    margin: 1.5rem 4rem;\r\n    height: 4rem;\r\n    width: fit-content;\r\n    white-space: nowrap;\r\n    float: left;\r\n    border-bottom: 1px solid rgb(161, 161, 161);\r\n    min-height: 4rem;\r\n    line-height: 4rem;\r\n}\r\n\r\n.mailing-type-tabs-wrapper span{\r\n    margin-left: 1.6rem;\r\n    margin-right: 1.6rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    padding-bottom: 0.8rem;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    margin-top: auto;\r\n}\r\n\r\n.mailing-type-tabs-wrapper span.active{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}\r\n\r\n.mailing-item-info__channels-block {\r\n    width: 75%;\r\n    display: block;\r\n}\r\n\r\n.mailing-item-info__channels-label {\r\n    float: left;\r\n    min-width: 9rem;\r\n    height: 100%;\r\n}\r\n\r\n.mailing-item-info__channels-choose {\r\n    text-align: left;\r\n    float: left;\r\n    display: grid;\r\n    margin-left: -2rem;\r\n    padding-left: 2px;\r\n}\r\n\r\n.mailing-item-info__channels-choose .visible-checkbox {\r\n    margin-left: 1.8rem;\r\n    margin-right: .5rem;\r\n    position: relative;\r\n    opacity: 1; \r\n    pointer-events: all;\r\n}\r\n\r\n.mailing-item-info__choosen-channels {\r\n    width: 70%;\r\n    float: left;\r\n}\r\n\r\n.mailing-item-info__channel-container {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.mailing-item-info__channel-image {\r\n    width: 2.6rem;\r\n    height: 2.6rem;\r\n    margin-left: .5rem;\r\n}\r\n\r\n.mailing-item-info__channel-externalid {\r\n    vertical-align: 0.6rem;\r\n    margin-left: 1.8rem;\r\n}\r\n\r\n.channels-selector-wrapper {\r\n    margin-left: 16rem;\r\n    width: 65%;\r\n    height: 42rem;\r\n    max-height: 42rem;\r\n    border: 1px solid #dcdcdc;\r\n    padding: 1rem;\r\n    border-radius: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
